import * as ACTIONS from '../constants/options';

const initialState = {
  source: '',
};

function options (state = initialState, action) {
  switch (action.type) {
    case ACTIONS.OPTIONS.SET:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

export default options;
